import { css } from "azure-devops-ui/Util";
import React from "react";

import "./tileoverlay.css";

export type OverlayLayout = "none" | "bottom" | "center" | "split";

export interface ITileOverlayProps {
  className?: string;
  id?: string;
}

export function TileOverlay(props: ITileOverlayProps & { children?: React.ReactNode }): React.ReactElement {
  const { children, className, id } = props;

  return (
    <>
      <div className={css("tile-overlay", className, "absolute-fill flex-column flex-grow rounded-6 pointer-events-none")} id={id}>
        {children}
      </div>
      <div className="tile-overlay-border absolute-fill flex-column pointer-events-none rounded-6"></div>
    </>
  );
}
